import './navigation-menu.scss';
import React, { useMemo } from 'react';
import CustomIcon from 'src/components/shared/custom-icon/custom-icon';
import { Link } from 'react-router-dom';
import { useStores } from '../../store';
import { observer } from 'mobx-react-lite';
import { NavigationMenuOption } from './navigation-menu-options';

interface NavigationMenuProps {
    navigationMenuOptions: NavigationMenuOption[];
    activeKey: string;
    calculatePath: (type: string) => string;
}

export const NavigationMenu: React.FC<NavigationMenuProps> = observer(({ navigationMenuOptions, activeKey, calculatePath }) => {
    const { fwVersionStore } = useStores();

    const handleClick = (index: number) => {
        if (fwVersionStore.isProtAsstOpen) {
            void fwVersionStore.setProtAsstActIdx(index);
        }
    };

    const disabledStatus = useMemo(() => {
        return navigationMenuOptions.map((_, index) => fwVersionStore.isDisabledProtectionTypeOnProtAsst(index));
    }, [fwVersionStore.protAsstActIdx]);

    return <div className="navigation-menu">
        {navigationMenuOptions.map(({ type, label, icon }, index) =>
            <Link key={type}
                to={calculatePath(type)}
                onClick={() => handleClick(index)}
                className={`navigation-menu-item ${activeKey === type ? 'active' : ''} ${disabledStatus[index] ? 'disabled' : ''}`}>
                <div className="navigation-button">
                    <CustomIcon type={icon}/>
                    <div>{label}</div>
                </div>
            </Link>)}
    </div>;
});
